const STYLES = {
  Dairy: "bg-sky-100 text-sky-800 border-sky-300",
  Egg: "bg-orange-100 text-orange-800 border-orange-300",
  Eggs: "bg-orange-100 text-orange-800 border-orange-300",
  Fish: "bg-indigo-100 text-indigo-800 border-indigo-300",
  Gluten: "bg-amber-100 text-amber-800 border-amber-300",
  Soy: "bg-green-100 text-green-800 border-green-300",
  Nuts: "bg-red-100 text-red-800 border-red-300",
};

export const AllergenBadge = ({ allergen }) => (
  <span
    data-testid={`allergen-badge-${allergen.toLowerCase()}`}
    className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${
      STYLES[allergen] || "bg-slate-100 text-slate-700 border-slate-300"
    }`}
  >
    {allergen}
  </span>
);
